import React from "react";
import { connect } from "react-redux";
import OrdersTable from "../Shared/OrdersTable";
import { useHistory } from "react-router-dom";

export const packingStationFilter = (orders, isBulkPack) => {
  const readyToPack = orders.filter(
    (o) => o.status === 3 && (o.hpBulkPack === 1) === isBulkPack
  );
  const chunkNumbers = new Set(readyToPack.map((o) => o.hpChunkNumber));
  return orders.filter((o) => chunkNumbers.has(o.hpChunkNumber));
};

const PackingStation = (props) => {
  const { orders, hpMode } = props;
  const history = useHistory();

  if (!hpMode) {
    history.push("/LineInfo");
  }

  if (orders) {
    return (
      <OrdersTable
        parent="Packing Station"
        isChunkSorted={true}
        orders={packingStationFilter(orders, false)}
      />
    );
  } else {
    return <div>Loading...</div>;
  }
};

const mapStateToProps = (state) => ({
  orders: state.order.orders,
  hpMode: state.system.hpMode,
});

export default connect(mapStateToProps, {})(PackingStation);
